import type { ContactInfo, User } from "@repo/types";
import { addressRepo } from "./addressRepo";
import { phoneNumberRepo } from "./phoneNumberRepo";

const contactInfoFields: Record<keyof ContactInfo, true> = {
  firstName: true,
  lastName: true,
  email: true,
  salutation: true,
  primaryAddress: true,
  primaryPhone: true,
};

export const contactInfoRepo = {
  init: (data?: Partial<ContactInfo>) => {
    return {
      firstName: "",
      lastName: "",
      email: "",
      salutation: "",
      primaryAddress: addressRepo.init(),
      primaryPhone: phoneNumberRepo.init(),
      ...data,
    };
  },

  extractFromUser(user?: User | null) {
    const contact: ContactInfo = contactInfoRepo.init();

    if (user) {
      for (const prop of Object.keys(
        contactInfoFields
      ) as (keyof ContactInfo)[]) {
        contact[prop] = user[prop] as never; // force-casted: fields should always match
      }
    }

    return contact;
  },
};
